export default "__VITE_ASSET__j3gMtzmU__"